import axios from "axios/index";
import { dispatchError, NMS_API_BASE,  nmsconfig as NmsConfig } from "../api";

export default store => {
  return {
    $store: store,
    list() {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(NmsConfig(this.$store), {
          method: "get",
          url: NMS_API_BASE + "/device/"
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    list_apps() {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(NmsConfig(this.$store), {
          method: "get",
          url: NMS_API_BASE + "/application/available_apps/"
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    update_apps(id, apps) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(NmsConfig(this.$store), {
          method: "post",
          url: NMS_API_BASE + "/device/" + id + "/update_device/",
          data: {
            version: apps
          }
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    list_device_apps(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(NmsConfig(this.$store), {
          method: "get",
          url: NMS_API_BASE + "/deviceapp/?device=" + id
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    get_device(mac) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(NmsConfig(this.$store), {
          method: "get",
          url: NMS_API_BASE + "/device/?mac=" + mac
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    update_device_conf(id, data) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(NmsConfig(this.$store), {
          method: "put",
          url: NMS_API_BASE + "/deviceapp/" + id + "/",
          data: data
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    start_application_state(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(NmsConfig(this.$store), {
          method: "POST",
          url: NMS_API_BASE + "/deviceapp/" + id + "/start/"
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    stop_application_state(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(NmsConfig(this.$store), {
          method: "POST",
          url: NMS_API_BASE + "/deviceapp/" + id + "/stop/"
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    delete_application(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(NmsConfig(this.$store), {
          method: "DELETE",
          url: NMS_API_BASE + "/deviceapp/" + id + "/"
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    }
  };
};
